import { useState } from "react";
import {
  createStudentsAPIEndpoint,
  EndPoints,
} from "../../../../services/StudentAPIs";

import { Dialog, DialogContent, DialogTitle, Button } from "@mui/material";

const StudentStatusToggle = ({
  student,
  fetchStudents,
  page,
  pageSize,
  search,
}) => {
  const [open, setOpen] = useState(false);

  const handleConfirm = () => {
    createStudentsAPIEndpoint(EndPoints.toggleStudentStatus)
      .putById(student.id, {})
      .then(() => {
        fetchStudents(page, pageSize, search);
        setOpen(false);
      })
      .catch((error) => {
        console.error("Error updating student status:", error);
        setOpen(false);
      });
  };

  const confirmMessage = student.isActive
    ? "Are you sure you want to deactivate this student?"
    : "Are you sure you want to activate this student?";

  return (
    <>
      <Button
        variant="outline"
        onClick={() => setOpen(true)}
        className={`btn-toggle-status ${
          student.isActive ? "deactivate" : "activate"
        }`}
      >
        {student.isActive ? "Deactivate" : "Activate"}
      </Button>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="confirm-dialog">
          <DialogTitle className="confirm-dialog-title">
            Confirm Action
          </DialogTitle>

          <p className="confirm-dialog-message">{confirmMessage}</p>
          <DialogContent className="confirm-dialog-actions">
            <Button
              variant="outline"
              onClick={() => setOpen(false)}
              className="cancel-button"
            >
              Cancel
            </Button>
            <Button
              className={student.isActive ? "deactivate" : "activate"}
              onClick={handleConfirm}
            >
              Yes, {student.isActive ? "Deactivate" : "Activate"}
            </Button>
          </DialogContent>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default StudentStatusToggle;
